






























import { Component, Vue } from 'vue-property-decorator'
import VButton from '@/components/VButton.vue'
import VInput from '@/components/VInput.vue'
import VDropdown from '@/components/VDropdown.vue'
import { Action } from 'vuex-class'
import * as types from '@/store/content/types'
import ValidatedForm from '@/utilities/validation/validatedform.ts'
import FormField from '@/utilities/validation/formfield.ts'
import urlValidator from '@/utilities/validators/url.ts'
import nonEmptyValidator from '@/utilities/validators/nonempty.ts'

@Component({ components: { VButton, VDropdown, VInput } })
export default class VSuggestionForm extends Vue {
  @Action('contentFormats', { namespace: 'content' }) getContentFormats!: types.ContentFormatsAction
  @Action('contentTypes', { namespace: 'content' }) getContentTypes!: types.ContentTypesAction
  @Action('suggest', { namespace: 'content' }) suggest!: types.SuggestAction

  private suggestionForm = new ValidatedForm({
    url: new FormField(urlValidator, ''),
    description: new FormField(nonEmptyValidator, ''),
    contentFormat: new FormField(() => [], ''),
    contentType: new FormField(() => [], '')
  })

  private typeOptions: Array<{ label: string; value: string }> = []
  private formatOptions: Array<{ label: string; value: string }> = []
  private submitting = false
  private success = false

  private created () {
    this.getContentFormats().then((response) => {
      this.formatOptions = response.map((format) => { return { label: format.name.toLowerCase(), value: format.name } })
    })
    this.getContentTypes().then((response) => {
      this.typeOptions = response.map((format) => { return { label: format.name.toLowerCase(), value: format.name } })
    })
  }

  private resetForm () {
    this.suggestionForm.resetForm()
    this.submitting = false
    this.success = false
  }

  private submit () {
    if (this.suggestionForm.validateForm()) {
      this.submitting = true
      this.suggest({
        url: this.suggestionForm.fields.url.value,
        description: this.suggestionForm.fields.description.value,
        contentFormat: this.suggestionForm.fields.contentFormat.value,
        contentType: this.suggestionForm.fields.contentType.value,
        category: parseInt(this.$route.params.category)
      }).then(() => {
        this.success = true
      }).finally(() => {
        this.submitting = false
      })
    }
  }
}
